// Order matters: the first match wins, and the patterns are unanchored.
const PORTAL_HOST_PATTERNS = [
  ["admin", /admin.*\.penchecks\.com/],
  ["auth", /auth.*\.penchecks\.com/],
  ["client", /amplify.*\.penchecks\.com/],
  ["participant", /my.*\.penchecks\.com/],
  ["nationalRegistry", /unclaimedretirementbenefits\.com/],
  ["benefitElection", /.*mybenefitelection\.com/],
  ["advisor", /advisorportal.*\.penchecks\.com/],
  ["accountHolder", /nextlevel.*\.penchecks\.com/],
];

export const portalForHost = (host) =>
  PORTAL_HOST_PATTERNS.find(([, pattern]) => pattern.test(host))?.[0] ?? null;
